import { MainViewType } from "../../models/view";
import { ActionLocal } from "./actions.service";
import { type } from "../../common/utils";

export class ApplicationToolbarActions {
  static ActionType = {
    VIEW_TYPE: type("[ApplicationToolbarActions] VIEW_TYPE"),
    SORT_FIELD: type("[ApplicationToolbarActions] SORT_FIELD"),
    CHANGE_SORT_DIRECTION: type(
      "[ApplicationToolbarActions] CHANGE_SORT_DIRECTION"
    ),
    SEARCH: type("[ApplicationToolbarActions] SEARCH"),
    SIDE_BAR_OPENED: type("[ApplicationToolbarActions] SIDE_BAR_OPENED"),
    SWITCH_SIDE_BAR: type("[ApplicationToolbarActions] SWITCH_SIDE_BAR")
  };

  public static setViewType(item: MainViewType): ActionLocal {
    return {
      type: ApplicationToolbarActions.ActionType.VIEW_TYPE,
      payload: item
    };
  }

  public static setSortField(item: string): ActionLocal {
    return {
      type: ApplicationToolbarActions.ActionType.SORT_FIELD,
      payload: item
    };
  }

  public static changeSortDirection(direction: number): ActionLocal {
    return {
      type: ApplicationToolbarActions.ActionType.CHANGE_SORT_DIRECTION,
      payload: direction
    };
  }

  public static setSearch(item: string): ActionLocal {
    return { type: ApplicationToolbarActions.ActionType.SEARCH, payload: item };
  }

  public static setSideBarOpened(opened: boolean): ActionLocal {
    return { type: ApplicationToolbarActions.ActionType.SIDE_BAR_OPENED, payload: opened };
  }

  public static switchSideBar(): ActionLocal {
    return { type: ApplicationToolbarActions.ActionType.SWITCH_SIDE_BAR};
  }

}
